import { IS_BASE, IS_DUAL, IS_ELEC, IS_GAS, IS_HP_HC } from '../../../../SubscriptionForm/Common/constants'

// todo-v2: clean the data and put only needed ones
export const amountParametersGeneration = ({
  workflowName,
  contractId,
  country,
  activeAddress,
  activeCharacteristics,
  activeContractDetails,
  clientPreferences,
  consumptionData,
  offerConfig,
  activeElecData,
}) => {
  const { city, inseeCode, zipcode, surface, heatingEnergy, hotwaterEnergy, electricityMeter } = activeAddress || {}
  const { prestationType, energyType } = activeCharacteristics || {}
  const { offerId } = activeContractDetails || {}
  const { clientType } = clientPreferences || {}
  const { comparator_id: comparatorId } = offerConfig || {}
  const { carBase, carHP, carHC, carGas } = consumptionData || {}

  const options = {}
  options.workflowName = workflowName || ''
  options.contract_id = contractId || ''
  options.country = country || ''
  options.city_id = inseeCode || ''
  options.zipcode = zipcode || ''
  options.city = city || ''
  options.prestation_type = prestationType || ''
  options.energy_type = energyType || ''
  options.contract_type = clientType || ''
  options.offer_id = offerId ? parseInt(offerId) : ''
  options.comparator_id = comparatorId || ''

  if (energyType === IS_DUAL || energyType === IS_ELEC) {
    const { meterOption, meterPower } = activeElecData || {}
    const { pdlNo } = electricityMeter || {}
    options.meter_power_elec = meterPower || ''
    options.meter_option_elec = meterOption || ''
    options.meter_id_elec = pdlNo || ''

    if (meterOption === IS_BASE) {
      options.car_elec_base = carBase || 0
    }
    if (meterOption === IS_HP_HC) {
      options.car_elec_hp = carHP || 0
      options.car_elec_hc = carHC || 0
    }
  }

  if (energyType === IS_DUAL || energyType === IS_GAS) {
    options.car_gas = carGas || 0
  }

  options.surface = surface || '0'
  options.hotwater_energy = hotwaterEnergy || ''
  options.heating_energy = heatingEnergy || ''

  /*
  options.append('zoho_id', customerData.zohoId)
  options.append('conso_residence_type', mainAddressData.residenceType ?? '-1')
  options.append('housing_type', mainAddressData.housingType ?? '')

  if (country === 'it') {
    options.append('city_id', mainAddressData.cityId ?? '')
  }

  options.append('organisation_id', energyContractData.providerId ? parseInt(energyContractData.providerId) : '')
  options.append('is_debordement', energyContractData.isDebordement ?? '0')
  options.append('payment_mode_real', billingData.realPayment ?? '')
  options.append('mes_emergency', energyContractData.mesEmergency ?? '')

  options.append('cooking_energy', energyConsumptionData.cooking)


  if (energyCharacteristicsData.energyType === 'dual' || energyCharacteristicsData.energyType === 'elec') {
   
    if (electricityMeterData.meterType) {
      options.append('meter_type_elec', electricityMeterData.meterType)
    }
    options.append('consumption_base', energyConsumptionData.consumptionBase ?? 0)
    options.append('consumption_biorariaF1', energyConsumptionData.consumptionBiorariaF1 ?? 0)
    options.append('consumption_biorariaF2', energyConsumptionData.consumptionBiorariaF2 ?? 0)
    options.append('consumption_biorariaF3', energyConsumptionData.consumptionBiorariaF3 ?? 0)
  }

  if (energyCharacteristicsData.energyType === 'dual' || energyCharacteristicsData.energyType === 'gas') {
    options.append('meter_id_gas', gasMeterData.pceNo)

    if (gasMeterData.meterType) {
      options.append('meter_type_gas', gasMeterData.meterType)
    }
  }

  options.append('disclaimer', customerData.dataCollectionAuth ? '1' : '0')
  */
  return options
}
